<div class="form-horizontal" [formGroup]="compositionFormGroup">
  <ng-container sobReactiveMultipleVariableInput totalOutputId="compositionTotalUO">
    <div class="form-group">
      <div class="row">
        <label class="control-label col-sm-4">Unit</label>
        <div class="col-sm-4">
          <sob-reactive-unit-select
            formControlName="compositionUnit"
            [quantity]="currentAnalysis.composition[0].quantity">
          </sob-reactive-unit-select>
        </div>
      </div>
    </div>

    <ng-container formArrayName="composition">
      <div class="form-group" *ngFor="let sv of currentAnalysis.composition; let i = index">
        <div class="row">
          <label class="control-label col-sm-4">
            {{ currentAnalysis.composition[i].name | titleCaseComposition }}
          </label>
          <div class="col-sm-4">
            <sob-reactive-variable-value-input [formControlName]="i" [valueMetaData]="sv">
            </sob-reactive-variable-value-input>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="form-group">
      <label class="pw-label control-label col-sm-4">Total</label>
      <div class="col-sm-4">
        <input type="text" class="form-control" formControlName="compositionTotal" id="compositionTotalUO" />
      </div>
    </div>
  </ng-container>
</div>
